import {parseCookies} from 'nookies'
import * as React from 'react'
import {Button, Spinner} from 'react-bootstrap'
import {APIURL} from '../../../../config/config'
import {toast} from 'react-toastify'

interface SuspenseBtnProps {
  fetchInfluencer: () => void
  item?: any
}

const UnSuspenseBtn = ({fetchInfluencer, item}: SuspenseBtnProps) => {
  const [loading, setLoading] = React.useState<boolean>(false)

  const cookies = parseCookies()
  const token = cookies?.token

  const handleInfluencerAction = async (influencer: any) => {
    setLoading(true)
    var myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)
    myHeaders.append('Content-Type', 'application/json')

    const body = JSON.stringify({
      influencer_id: influencer?.influencer_id,
    })

    const requestOptions: any = {
      method: 'POST',
      body,
      headers: myHeaders,
    }

    const response = await fetch(`${APIURL}/merchant/unsuspend-influencer`, requestOptions)
    const result = await response.json()

    if (result.success === true) {
      toast.success(result?.message)
      fetchInfluencer()
      setLoading(false)
    }
  }

  return (
    <Button
      className='btn btn-danger btn-sm'
      size='sm'
      onClick={() => handleInfluencerAction(item)}
      title='Suspend'
    >
      {loading ? <Spinner animation='border' size='sm' /> : 'Unsuspend'}
    </Button>
  )
}

export default UnSuspenseBtn
